export default class OrderSearchFilter {
    OrderId?: string;
    OrderCode?: number;
    PaymentCode?: string;
    Email?: string;
    Phone?: string;
    ServiceConnection?: string;
}